/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * OperationStatus is utilized to indicate which Operation status are considered successful.
 * @export
 * @interface RosettaOperationStatus
 */
export interface RosettaOperationStatus {
    /**
     * The status is the network-specific status of the operation.
     * @type {string}
     * @memberof RosettaOperationStatus
     */
    status: string;
    /**
     * An Operation is considered successful if the Operation.Amount should affect the Operation.Account. Some blockchains (like Bitcoin) only include successful operations in blocks but other blockchains (like Ethereum) include unsuccessful operations that incur a fee. To reconcile the computed balance from the stream of Operations, it is critical to understand which Operation.Status indicate an Operation is successful and should affect an Account.
     * @type {boolean}
     * @memberof RosettaOperationStatus
     */
    successful: boolean;
}

export function RosettaOperationStatusFromJSON(json: any): RosettaOperationStatus {
    return RosettaOperationStatusFromJSONTyped(json, false);
}

export function RosettaOperationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaOperationStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'successful': json['successful'],
    };
}

export function RosettaOperationStatusToJSON(value?: RosettaOperationStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'successful': value.successful,
    };
}

